document.addEventListener('DOMContentLoaded', function () {

  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      });
  }
  updateCartCount();

  document.querySelectorAll('.product-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('.product-form__btn');
      const orig = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(r => r.json())
        .then(() => {
          btn.textContent = 'Added';
          updateCartCount();
          setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
        })
        .catch(() => { btn.textContent = 'Error'; btn.disabled = false; });
    });
  });

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.product-card, .category-card, .work-card, .process-step').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

});
